import { HStack, Box, Separator } from '@chakra-ui/react';
import { ChevronRightIcon, FileIcon, HistoryIcon, ScienceIcon, SearchIcon } from 'assets/icons/v2';
import { ReactElement } from 'react';
import { IconType } from 'types/iconType';
import { SearchContentType } from '@novaheal/types';

type SearchDropdownListItemProps = {
  text: string;
  onItemClick: () => void;
  onTopItemClick: () => void;
  iconType: IconType;
  contentType?: SearchContentType;
  shouldHideDivider?: boolean;
  isTopItem?: boolean;
};

export const SearchDropdownListItem = ({
  text,
  onItemClick,
  onTopItemClick,
  iconType,
  contentType,
  shouldHideDivider = false,
  isTopItem = false,
}: SearchDropdownListItemProps): ReactElement => {
  const showHistory = iconType === IconType.HISTORY;

  const getContentTypeIcon = (): ReactElement => {
    if (showHistory) return <HistoryIcon color="icon.tertiary" mt="2px" boxSize="16px" />;
    if (isTopItem) {
      switch (contentType) {
        case SearchContentType.ARTICLE:
          return <FileIcon color="icon.tertiary" boxSize="16px" />;
        case SearchContentType.MEDICATION:
          return <ScienceIcon color="icon.tertiary" boxSize="16px" />;
        default:
          return <SearchIcon color="icon.tertiary" boxSize="16px" />;
      }
    }
    return <SearchIcon color="icon.tertiary" boxSize="16px" />;
  };

  const showArrow =
    contentType === SearchContentType.ARTICLE || contentType === SearchContentType.MEDICATION;
  const icon = getContentTypeIcon();

  const onClick = isTopItem ? onTopItemClick : onItemClick;

  return (
    <Box
      position="relative"
      cursor="pointer"
      _hover={{ bg: 'background.canvas' }}
      onMouseDown={onClick}
    >
      <HStack gap="10px" alignItems="center" w="full" align="left" py="11px" px="4">
        {icon}
        <Box
          as="button"
          color="text.primary"
          textStyle="body.m.regular"
          fontWeight="normal"
          bg="transparent"
          outline="none"
          _hover={{ background: 'transparent' }}
          textAlign="left"
          w="full"
        >
          {text}
        </Box>
        {showArrow && (
          <ChevronRightIcon color="icon.quaternary" h="18px" w="18px" />
        )}
      </HStack>
      {!shouldHideDivider && <Separator position="absolute" bottom="0" width="100%" height="1px" />}
    </Box>
  );
};
